/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsProjectListRequest {
    getFixupPrototypeFunction() { return AppSecopsProjectListRequest.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsProjectListRequest>): AppSecopsProjectListRequest {
        let obj = Object.assign(new AppSecopsProjectListRequest(), model);
        AppSecopsProjectListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsProjectListRequest>): AppSecopsProjectListRequest {
        if (!model) return null;
        return AppSecopsProjectListRequest.newInstance(<AppSecopsProjectListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsProjectListRequest) {
        if (!obj) return;

        models.AppSecopsProjectListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsProjectListRequest): boolean {
        Object.setPrototypeOf(obj, AppSecopsProjectListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
        if (this.filters) {
            models.AppSecopsProjectFilterBase.fixupPrototype(this.filters);
        }
        if (this.sort) {
            for (let val of this.sort) {
                models.AppSecopsProjectSortCriteria.fixupPrototype(val);
            }
        }
    }

    /**
     * Optional list context
     */
    list_context: models.ListContext;

    /**
     * Sort criteria
     */
    sort: Array<models.AppSecopsProjectSortCriteria>;

    /**
     * Filters for the request
     */
    filters: models.AppSecopsProjectFilterBase;

}
